import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, List, ListItem, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../utils/IconHandler';

const EditCategoryModal = ({ open, onClose, category, onUpdate }) => {
  
    const { t } = useTranslation();
    const [name, setName] = useState(category.name);
    const [subCategories, setSubCategories] = useState(category.subCategories);

    const handleSave = () => {
        if (subCategories.length === 0) {
            alert("Debes ingresar al menos una subcategoría");
            return;
        }
        onUpdate({ ...category, name, subCategories });
        onClose();
    };

    const handleAddSubcategory = () => {
        const newSubcategory = { name: '', categoryId: category.id };
        setSubCategories([...subCategories, newSubcategory]);
    };

    const handleSubcategoryNameChange = (index, newName) => {
        const updatedSubCategories = subCategories.map((sub, idx) => {
        if (idx === index) {
            return { ...sub, name: newName };
        }
        return sub;
        });
        setSubCategories(updatedSubCategories);
    };

    const handleSubcategoryDelete = (id) => {
        const updatedSubCategories = subCategories.filter(sub => sub.id !== id);
        setSubCategories(updatedSubCategories);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t('edit_category')}</DialogTitle>
            <DialogContent>
                <TextField
                style={{ marginTop: "4px", marginBottom: "8px" }}
                label={t('category_name')}
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
                />
                <List>
                {subCategories.map((sub, index) => (
                    <ListItem key={sub.id}>
                    <TextField
                        label={t('sub_category')}
                        value={sub.name}
                        onChange={(e) => handleSubcategoryNameChange(index, e.target.value)}
                        fullWidth
                    />
                    <IconButton style={{ marginLeft: "4px" }} onClick={() => handleSubcategoryDelete(sub.id)}>
                        {getIcon('close')}
                    </IconButton>
                    </ListItem>
                ))}
                <ListItem>
                    <Button onClick={handleAddSubcategory} startIcon={getIcon('add')}>
                    {t('add_sub_category')}
                    </Button>
                </ListItem>
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('cancel')}</Button>
                <Button onClick={handleSave} color="primary" variant="contained">{t('save')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditCategoryModal;
